import UniqueIdHelper from "../helper/UniqueIdHelper";
import Content from "./Content";
import CrossCommSession from "./CrossCommSession";
import {EventType} from "./EventType";
import {ViewInfoViews} from "./ViewInfo";

export default class EventMessage {
    public userId: number;
    public organizationId: number;
    public sessionId: number;
    public appVersion: number;
    public notificationEnabled: boolean | null = null;
    public postId: number;
    public postInPage: number;
    public pageSize: number;
    public pageItemIndex: number;
    public externalLinkId: number| null = null;
    public clickedUrl: string | null;
    public category: string;
    public eventType: string;
    public timestampUtc: string;
    public version: number;
    public eventId: string;
    public eventRef: string;
    public locationUrl: string;
    public userAgent: string;
    constructor(session: CrossCommSession, content: Content, eventType: EventType) {
        this.userId = session.userId;
        this.organizationId = session.organizationId;
        this.sessionId = session.id;
        this.appVersion = 1;
        this.notificationEnabled = null;
        this.postId = content.postId;
        this.postInPage = content.contentPosition.page;
        this.pageSize = content.contentPosition.pageSize;
        this.pageItemIndex = content.contentPosition.pageItemIndex;
        this.externalLinkId = null;
        this.clickedUrl = (eventType === EventType.CLICK) ? content.contentLink : null;
        this.category = "teams";
        this.eventType = eventType;
        this.timestampUtc = (new Date()).toJSON();
        this.version = 1;
        this.eventId = UniqueIdHelper.getUniqueEventId();
        if (content.contentPosition.viewId === ViewInfoViews.NEWSFEED) {
            this.eventRef = "newsfeed";
        } else if (content.contentPosition.viewId === ViewInfoViews.NOTIICATION) {
            this.eventRef = "notification";
        } else {
            this.eventRef = "search";
        }
        this.locationUrl = window.location.href;
        this.userAgent = navigator.userAgent;
    }

}
